import { createContext, useContext, useEffect, useState, } from "react";
import { connectCommonSocket, connectSocket, disconnectCommonSocket, disconnectSocket, } from "./socket";
import PropTypes from "prop-types";

const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);
    const [commonSoc, setCommonSoc] = useState(null);

    useEffect(() => {
        const newSocket = connectSocket();
        const s_common = connectCommonSocket()

        setSocket(newSocket);

        setCommonSoc(s_common)

        return () => {
            disconnectSocket();
            disconnectCommonSocket()
        };
    }, []);

    return (
        <SocketContext.Provider
            value={{ ConSocket: socket, CommonSocket: commonSoc }}
        >
            {children}
        </SocketContext.Provider>
    );
};

SocketProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export const useSocket = () => useContext(SocketContext);